import { useState, useRef } from 'react'

import { motion, AnimatePresence } from 'motion/react'
import { Button } from 'components/Global/Button'

export const MultiState = ({ blocks }) => {
  const [activeTab, setActiveTab] = useState<string>(blocks[0].label ?? '')
  const [height, setHeight] = useState(0)

  return (
    <div className="p-20 pb-0 text-darkGray">
      <div className="flex gap-4 rounded-12 bg-white p-4 text-11">
        {blocks.map((block) => {
          return (
            <Button
              key={block._key}
              className={`rounded-8 hover:!bg-lighterGray ${
                activeTab === block.label ? 'bg-lighterGray' : ''
              }`}
              onClick={() => {
                setActiveTab(block.label)
              }}
            >
              {block.label}
            </Button>
          )
        })}
      </div>
      <motion.div
        className="relative mt-16 w-full max-w-[1200px] rounded-24 bg-white shadow-md"
        initial={{ height: 'auto' }}
        animate={{ height: height > 0 ? height : 'auto' }}
      >
        <AnimatePresence mode="wait">
          {blocks.map((block) => {
            if (block.label !== activeTab) return null
            return (
              <motion.div
                id={`tab-${block.label.toLowerCase()}`}
                ref={(el) => {
                  setHeight(el?.scrollHeight ?? 0)
                }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{
                  duration: 0.4,
                  ease: 'easeInOut',
                }}
                key={`${block._key}-content`}
                className={`p-24
                ${
                  block.size === 'large'
                    ? 'text-48 uppercase leading-100 md:text-64'
                    : 'text-16 leading-120 md:text-24'
                }
              `}
              >
                {block.text}
              </motion.div>
            )
          })}
        </AnimatePresence>
      </motion.div>
    </div>
  )
}
